import React from 'react';

const NhisThirdPartyTerm = () => {
  return (
    <section className="sub_container pt-0">
      <ul className="hd_info">
        <li>
          <span>공고일</span>
          2024.12.31
        </li>
        <li>
          <span>개정사항</span>
          약관내용수정
        </li>
        <li>
          <span>시행일</span>
          2024.12.31
        </li>
      </ul>

      <div className="Padding-20 text">
        (주)오픈잇 (이하 "회사")가 제공하는 어플리케이션 서비스 헬스업(이하 “서비스”)의 건강검진 연동 간편인증과 관련하여 제3자 정보제공동의 내용을 고지 하오니
        동의여부를 결정하여 주시기 바랍니다.
        <br />
        <br />
        <strong>1.개인정보를 제공받는 자</strong>
        <br />
        이용자가 선택한 인증사업자
        <br />
        <br />
        <strong>2.개인정보를 제공받는 자의 개인정보 이용 목적</strong>
        <br />
        간편인증 시 본인인증 또는 전자서명
        <br />
        <br />
        <strong>3.제공하는 개인정보의 항목</strong>
        <br />
        생년월일, 성명, 휴대폰번호
        <br />
        <br />
        <strong>4.개인정보를 제공받는 자의 개인정보 보유 및 이용 기간</strong>
        <br />
        본인인증 또는 전자서명 후 즉시 파기
        <br />
        <br />
        <strong>5.동의 거부 권리</strong>
        <br />
        신청인은 위의 개인정보 제3자 제공에 대한 동의를 거부할 권리가 있습니다. 그러나 동의를 거부할 경우 대표 서비스 이용이 제한될 수 있습니다.
        <br />
        <br />
      </div>
    </section>
  );
};

export default NhisThirdPartyTerm;
